import * as types from "./types";

export default (state = { isFetching: false, data: {} }, action) => {
  switch (action.type) {
    case types.FETCH_BRAND_SUCCESS:
      // This setting of data.theme is temporary until we can ensure that
      // the rest of bookshelf is okay with changing the Chameleon config or removing
      // the brand altogether.
      action.data.theme = action.data.Theme.secondary;
      return {
        brandKey: action.brandKey,
        isFetching: false,
        data: action.data
      };
    case types.FETCH_BRAND_REQUEST:
      return { ...state, brandKey: action.brandKey, isFetching: true };
    case types.FETCH_BRAND_FAILURE:
      return { ...state, brandKey: action.brandKey, isFetching: false };
    default:
      return state;
  }
};
